// External libs
import { createAction } from '@reduxjs/toolkit'

const closeAction = createAction('multiStoreDropDialog/close')

const clearAction = createAction('multiStoreDropDialog/clear')

const maximizeAction = createAction('multiStoreDropDialog/maximize')

const openAction = createAction('multiStoreDropDialog/open')

const clear = () => (dispatch: any) => {
  dispatch(clearAction())
}

const close = () => (dispatch: any) => {
  dispatch(closeAction())
}

const maximize = () => (dispatch: any) => dispatch(maximizeAction())

const open = () => (dispatch: any) => {
  dispatch(openAction())
}
const actions = {
  clear,
  clearAction,
  close,
  closeAction,
  maximize,
  maximizeAction,
  open,
  openAction,
}

export default actions
